import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { getColorCode } from '../../../../api/color';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  digitalClassList,
  timerData
} from '../../../../actions/digitalClassActions';
import { dateFormat } from '../../../../api/dateFormat';
// Material Imports
import Grid from '@material-ui/core/Grid';
// Components
import TimerCard from '../../../../components/TimerCard.js';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';
import { Link } from 'react-router-dom';
import PageHeading from '../../../../components/PageHeading';
import NoData from '../../../../components/NoData';
import ScrollToTop from '../../../../components/ScrollToTop';
import { openSnackBar } from '../../../../actions/snackbarAction';

const DigitalClassroomLayout = props => {
  // State
  // const [setIsFetching] = useState(false);
  const [isDigitalClassFetching, setIsDigitalClassFetching] = useState(false);
  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  // Redux
  const dispatch = useDispatch();
  const digitalClassListData = useSelector(state =>
    get(state, 'digitalClassReducer.data', {})
  );
  const errorMessage = useSelector(state =>
    get(state, 'digitalClassReducer.errorMessage', '')
  );

  // Functions
  useEffect(() => {
    setIsDigitalClassFetching(true);
    digitalClassList(loginData, dispatch).then(() => {
      setIsDigitalClassFetching(false);
    });
  }, []);

  const onRefresh = React.useCallback(() => {
    setIsDigitalClassFetching(true);
    digitalClassList(loginData, dispatch).then(() => {
      populatedigitalClassList();
      setIsDigitalClassFetching(false);
    });
  });

  const handler = expiry => {
    dispatch(timerData(expiry));
  };

  const populatedigitalClassList = () => {
    let list = [];
    var i = 0;
    if (!isEmpty(digitalClassListData))
      digitalClassListData.map((data, index) => {
        let classList = [];
        data.listClass.map((classes, classIndex) => {
          let uniquekey = `${index}${classIndex}`;
          if (!(props.totalCard && i >= props.totalCard))
            classList.push(
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={uniquekey}
                className="flex"
              >
                {classes.RemainingTime < 0 ? (
                  <Link
                    to={'/digital-classroom/' + classes.UniqueCode}
                    className="timer-card-container"
                  >
                    <ScrollToTop />
                    <TimerCard
                      index={uniquekey}
                      key={uniquekey}
                      subject={classes.SubjectName}
                      dateTime={`${dateFormat(data.ClassDate)} at ${
                        classes.ClassTime
                      }`}
                      topic={classes.ModuleNo}
                      handler={() => handler(classes.Expiry)}
                      start={'EXPIRE IN'}
                      initialTime={classes.Expiry * 1000}
                      callback={onRefresh}
                      bottomColor={getColorCode(
                        get(classes, 'ClassCode', '').replace('bg-', '')
                      )}
                    />
                  </Link>
                ) : (
                  <TimerCard
                    index={uniquekey}
                    key={uniquekey}
                    subject={classes.SubjectName}
                    dateTime={`${dateFormat(data.ClassDate)} at ${
                      classes.ClassTime
                    }`}
                    bottomColor={getColorCode(
                      get(classes, 'ClassCode', '').replace('bg-', '')
                    )}
                    topic={classes.ModuleNo}
                    handler={() => {
                      dispatch(
                        openSnackBar({
                          message:
                            'Your Scheduled class is yet to start, please wait',
                          severity: 'warning'
                        })
                      );
                    }}
                    start={'START IN'}
                    initialTime={classes.RemainingTime * 1000}
                    callback={onRefresh}
                  />
                )}
              </Grid>
            );
          i = i + 1;
        });
        return list.push(
          <React.Fragment key={index}>{classList}</React.Fragment>
        );
      });

    return list;
  };

  return (
    <React.Fragment>
      {props.heading ? (
        <PageHeading titlePrimary="Digital" titleSecondary="Classroom" />
      ) : (
        ''
      )}
      {isDigitalClassFetching ? (
        <LoadingSkeleton type="bigcardlist" />
      ) : (
        <Grid container spacing={2}>
          {!isEmpty(populatedigitalClassList()) ? (
            populatedigitalClassList()
          ) : (
            <NoData
              message={
                !isEmpty(errorMessage) ? errorMessage : 'No data Available'
              }
            />
          )}
        </Grid>
      )}
    </React.Fragment>
  );
};

export default DigitalClassroomLayout;

DigitalClassroomLayout.propTypes = {
  heading: PropTypes.bool,
  totalCard: PropTypes.number
};

DigitalClassroomLayout.defaultProps = {
  heading: true
};
